import React, {
  createContext, useContext, useEffect, useMemo
} from 'react';
import { preloadActiveTools } from '../hooks/activeToolsCache';

const AgentContext = createContext();

export const AgentProvider = ({ children, agentId }) => {
  const value = useMemo(() => ({ agentId }), [agentId]);

  useEffect(() => {
    if (agentId) preloadActiveTools(agentId);
  }, [agentId]);

  return (
    <AgentContext.Provider value={value}>
      {children}
    </AgentContext.Provider>
  );
};

export const useOptionalAgent = () => useContext(AgentContext);

export const useAgent = () => {
  const context = useOptionalAgent();
  if (!context) {
    throw new Error('useAgent must be used within AgentProvider');
  }
  return context;
};
